import { createSlice, isAnyOf, PayloadAction } from '@reduxjs/toolkit'
import {
  initialState,
  type ScalesReadingState,
} from './latestScalesReadingState'
import { scalesReadingReceived } from './actions'
import {
  MAX_SCALES_READINGS,
  SCALES_READING_VALUE_UPDATE_THRESHOLD_G,
} from '../../../utils/constants'

const MS_IN_DAY = 60 * 60 * 60 * 24

const matchScalesReadingReceived = isAnyOf(scalesReadingReceived)

const scalesReadingSlice = createSlice({
  name: 'scalesReading',
  initialState,
  reducers: {
    updateScalesReading: (
      state,
      { payload: newState }: PayloadAction<Partial<ScalesReadingState>>,
    ) => {
      Object.assign(state, newState)
    },
  },
  extraReducers(builder) {
    builder.addMatcher(matchScalesReadingReceived, (state, { payload }) => {
      const previousValueDelta = payload.value - state.reading.value
      const updateValueDelta = payload.value - state.previousUpdatedValue

      if (!state.isValid) {
        state.updatedAt = payload.createdAt
        state.isValid = true
      } else {
        const isUpdateValueDeltaWithinThreshold =
          Math.abs(updateValueDelta) <= SCALES_READING_VALUE_UPDATE_THRESHOLD_G

        if (isUpdateValueDeltaWithinThreshold) {
          state.msSinceLastUpdate = payload.createdAt - state.updatedAt
          state.msSinceLastUpdate = Math.min(MS_IN_DAY, state.msSinceLastUpdate)
          state.numReadingsSinceUpdate++
          state.numReadingsSinceUpdate = Math.min(
            MAX_SCALES_READINGS,
            state.numReadingsSinceUpdate,
          )
        } else {
          state.msSinceLastUpdate = 0
          state.numReadingsSinceUpdate = 0
          state.updatedAt = payload.createdAt
          state.previousUpdatedValue = payload.value
        }
      }
      state.receivedAt = payload.createdAt
      state.previousValueDelta = previousValueDelta
      Object.assign(state.reading, payload)
    })
  },
})

export const { updateScalesReading } = scalesReadingSlice.actions
export const { reducer: ScalesReadingReducer } = scalesReadingSlice
